export const styles = {
  container: {
    marginRight: 5
  }
};
